var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotochange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photo change"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 83",
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#B63940"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 22.5C23.0147 22.5 21 24.5147 21 27C21 29.4853 23.0147 31.5 25.5 31.5C27.9853 31.5 30 29.4853 30 27C30 24.5147 27.9853 22.5 25.5 22.5ZM22 27C22 25.067 23.567 23.5 25.5 23.5C27.433 23.5 29 25.067 29 27C29 28.933 27.433 30.5 25.5 30.5C23.567 30.5 22 28.933 22 27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.809 17H22.191L20.191 21H16V35H35V21H30.809L28.809 17ZM20.809 22L22.809 18H28.191L30.191 22H34V34H17V22H20.809Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotochange);
export default __webpack_public_path__ + "static/media/Photo change.46d556ce3c766f9c5d224a3c636a4981.svg";
export { ForwardRef as ReactComponent };